import { createContext, useState } from "react";

export const ThemeContext = createContext()

export const ThemeProvider = ({children}) => {

    const [launchEmojis, setLaunchEmojis] = useState(false)

    return (
        <ThemeContext.Provider value={{launchEmojis, setLaunchEmojis}}>
                {children}
        </ThemeContext.Provider>
    )

}
